function selectColor(color) {

 var color = color.toLowerCase().replace(/\s/g, "");;

    const currentWidth = window.innerWidth;
    var allItems = '';
if (currentWidth > 767) {
    allItems = document.querySelectorAll('.js-slider--tablet-up li[data-color]');
} else {
    allItems = document.querySelectorAll('li[data-color]');
}






    allItems.forEach(li => {
        const itemColor = li.getAttribute('data-color').toLowerCase().replace(/\s/g, "");;
console.log(itemColor+ " itemColor");

        console.log(color+ " color");
        if (itemColor !== color && itemColor!== '') {
            li.style.display = 'none';
        } else {
            li.style.display = 'block'
        }
    });
}
document.addEventListener('DOMContentLoaded', (event) => {
    const inputs = document.querySelectorAll('.js-swatch-input__input');


    inputs.forEach(input => {

        if (input.checked) {
            console.log('strast' + input.getAttribute('data-color').toLowerCase().replace(/\s/g, ""));
            selectColor(input.getAttribute('data-color').toLowerCase().replace(/\s/g, ""));
        }

    });
});

const headerElement = document.querySelector('.header');
const popupElement = document.querySelector('.sticky-add-to-cart');

const MOBILE_MAX_WIDTH = 990;

function updateStickyPopupPosition() {
    if (!headerElement || !popupElement) {
        console.warn("error");
        return;
    }


    if (window.innerWidth <= MOBILE_MAX_WIDTH) {
        popupElement.style.top = '';
        return;
    }

    const headerHeight = headerElement.offsetHeight;
    popupElement.style.top = `${headerHeight}px`;
}

window.addEventListener('load', updateStickyPopupPosition);
window.addEventListener('resize', updateStickyPopupPosition);